/* SFSX accessibility layer (script half; styles are in sections/sfsx-a11y.liquid).
   Adds pause buttons to moving sections, gives controls the names and roles they are missing,
   and keeps keyboard focus from being dropped when a widget redraws itself. Changes no wording. */
(function () {
  if (window.__sfsxA11y) return;
  window.__sfsxA11y = true;

  var ICON = '<svg viewBox="0 0 12 12" aria-hidden="true" focusable="false" fill="currentColor"><g class="sfsx-pause__bars"><rect x="2" y="1" width="3" height="10"/><rect x="7" y="1" width="3" height="10"/></g><path class="sfsx-pause__play" d="M3 1l8 5-8 5z"/></svg>';

  function each(root, sel, fn) {
    var list = root.querySelectorAll(sel);
    for (var i = 0; i < list.length; i++) { try { fn(list[i], i); } catch (err) {} }
  }
  function txt(el) { return el ? (el.textContent || '').replace(/\s+/g, ' ').trim() : ''; }
  function set(el, name, value) { if (el && el.getAttribute(name) !== value) el.setAttribute(name, value); }
  function lostFocus() { var a = document.activeElement; return !a || a === document.body || !document.body.contains(a); }
  function focusOn(el) { if (!el) return; try { el.focus({ preventScroll: true }); } catch (err) { el.focus(); } }
  function srNode(host, key) {
    var n = host.querySelector('[data-sfsx-sr="' + key + '"]');
    if (!n) { n = document.createElement('span'); n.className = 'sfsx-sr'; n.setAttribute('role', 'status'); n.setAttribute('data-sfsx-sr', key); host.appendChild(n); }
    return n;
  }
  function say(node, text) { if (node && node.textContent !== text) node.textContent = text; }

  /* ---------- pause buttons ---------- */
  document.addEventListener('click', function (e) {
    var b = e.target && e.target.closest ? e.target.closest('[data-sfsx-pause]') : null;
    if (!b) return;
    var r = b.closest('[data-sfsx-motion]');
    if (!r) return;
    var on = r.classList.toggle('is-paused');
    b.setAttribute('aria-pressed', on ? 'true' : 'false');
  });
  /* root: the moving section. host: where the button goes. before: optional element to put the button in front of. */
  function addPause(root, host, label, cls, before) {
    if (!root || !host || root.querySelector('[data-sfsx-pause]')) return;
    root.setAttribute('data-sfsx-motion', '');
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'sfsx-pause ' + cls;
    b.setAttribute('data-sfsx-pause', '');
    b.setAttribute('aria-pressed', 'false');
    b.setAttribute('aria-label', label);
    b.innerHTML = ICON;
    if (before && before.parentNode === host) host.insertBefore(b, before); else host.appendChild(b);
  }
  function pauses() {
    each(document, '.sfsx-hero', function (s) {
      var m = s.querySelector('.sfsx-hero__media');
      if (m && (m.querySelector('img') || m.querySelector('.sfsx-hero__card'))) addPause(s, m, 'Pause hero animation', 'sfsx-pause--corner');
    });
    each(document, '.sfsx-marquee', function (s) {
      var v = s.querySelector('.sfsx-marquee__viewport');
      if (v) addPause(s, s, 'Pause brand ticker', 'sfsx-pause--marquee', v);
    });
    each(document, '.sfsx-r3d', function (s) {
      var h = s.querySelector('.sfsx-r3d__head');
      if (h) addPause(s, h, 'Pause moving reviews', 'sfsx-pause--reviews');
    });
    each(document, '.sfsx-chero', function (s) {
      var img = s.querySelector('.sfsx-chero__media img');
      if (!img) return;
      addPause(s, s, 'Pause background motion', 'sfsx-pause--corner');
      set(img, 'alt', '');
    });
    each(document, '.collection--description .whx .whx-hero', function (h) {
      addPause(h, h, 'Pause background motion', 'sfsx-pause--corner');
    });
    each(document, '.sfsx-biz[data-sfsx-cg]', function (s) {
      var c = s.querySelector('.sfsx-cg__cap');
      if (c) addPause(s, c, 'Pause business gallery', 'sfsx-pause--gallery');
    });
  }

  /* ---------- names and roles ---------- */
  function names() {
    each(document, 'a.th_wlc_position_relative', function (a) {
      if (!a.getAttribute('aria-label')) a.setAttribute('aria-label', 'Wishlist');
      var g = a.querySelector('svg');
      if (g) { set(g, 'aria-hidden', 'true'); set(g, 'focusable', 'false'); }
    });
    each(document, '[data-modal-container],[data-modal-container-1]', function (m) { set(m, 'role', 'dialog'); });
    each(document, '[data-product-compare-drawer-remove]', function (b) {
      if (!b.getAttribute('aria-label')) b.setAttribute('aria-label', 'Remove from compare');
    });
    each(document, '.sfsx-r3d__cardstars[aria-label]', function (d) { set(d, 'role', 'img'); });
    each(document, 'a.sfsx-qob__sheet', function (a) {
      a.removeAttribute('aria-label');
      set(a, 'aria-hidden', 'true');
      set(a, 'tabindex', '-1');
    });
    each(document, '.sfsx-chero__crumbs > span:last-child, .sfsx-phero__crumbs > span:last-child', function (sp) {
      if (!sp.hasAttribute('aria-hidden')) set(sp, 'aria-current', 'page');
    });
    each(document, '.sfsx-ins-top label[aria-label] > input', function (i) { set(i, 'aria-label', i.parentNode.getAttribute('aria-label')); });
    /* product cards: name the picture link and the buttons after the product */
    each(document, '.productitem', function (card) {
      var t = txt(card.querySelector('.productitem--title'));
      if (!t || card.getAttribute('data-sfsx-named') === t) return;
      card.setAttribute('data-sfsx-named', t);
      set(card.querySelector('a.productitem--image-link'), 'aria-label', t);
      each(card, '.productitem--action button', function (b) {
        var own = b.getAttribute('data-sfsx-own') || txt(b) || b.getAttribute('aria-label') || '';
        if (!own) return;
        b.setAttribute('data-sfsx-own', own);
        b.setAttribute('aria-label', own + ': ' + t);
      });
      var cmp = card.querySelector('[data-compare-checkbox]');
      if (cmp) cmp.setAttribute('aria-label', (txt(card.querySelector('.productitem__compare-checkbox-text')) || 'Compare') + ' ' + t);
    });
  }

  /* ---------- bundle builder ---------- */
  var inBundle = false, bundleAt = 0;
  function inBB(e) { return !!(e.target && e.target.closest && e.target.closest('[data-sfsx-bb]')); }
  document.addEventListener('focusin', function (e) { inBundle = inBB(e); });
  document.addEventListener('pointerdown', function (e) { if (!inBB(e)) inBundle = false; }, true);
  document.addEventListener('click', function (e) { if (inBB(e)) bundleAt = Date.now(); }, true);
  document.addEventListener('keydown', function (e) { if (inBB(e)) bundleAt = Date.now(); }, true);
  function bundle() {
    each(document, '[data-sfsx-bb]', function (root) {
      set(root.querySelector('[data-next]'), 'role', 'status');
      each(root, '[data-slots] button[data-open]', function (b) {
        var lbl = txt(b.querySelector('.sfsx-bb__slot-lbl')), hint = txt(b.querySelector('.sfsx-bb__slot-hint'));
        var isNext = b.classList.contains('is-next');
        set(b, 'aria-label', (isNext ? lbl : lbl + ', add item') + (hint ? '. ' + hint : ''));
      });
      each(root, '[data-slots] h4', function (h) { set(h, 'role', 'heading'); set(h, 'aria-level', '3'); });
      each(root, '[data-list] [data-pick]', function (b) {
        var n = txt(b.closest('.sfsx-bb__opt') && b.closest('.sfsx-bb__opt').querySelector('.sfsx-bb__opt-name'));
        if (n) set(b, 'aria-label', 'Add ' + n);
      });
      var list = root.querySelector('[data-list]'), input = root.querySelector('[data-q]');
      if (list && input) {
        var empty = list.querySelector('.sfsx-bb__empty'), n = list.querySelectorAll('.sfsx-bb__opt').length;
        var typed = (input.value || '').trim().length >= 2;
        say(srNode(list.parentNode, 'bb'), !typed ? '' : (empty ? txt(empty) : n + (n === 1 ? ' result' : ' results')));
      }
      /* the builder redraws its slots after every pick or removal, which drops keyboard focus: put it on the next open slot */
      if (inBundle && lostFocus() && Date.now() - bundleAt < 6000 && !root.querySelector('dialog[open]')) {
        var slots = root.querySelector('[data-slots]');
        var next = slots && (slots.querySelector('.is-next') || slots.querySelector('[data-open]'));
        var add = root.querySelector('[data-add]');
        focusOn(next || (add && !add.disabled ? add : null));
      }
    });
  }

  /* ---------- insulated shipping switch: keep focus when the card redraws ---------- */
  var insKeep = null;
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || !t.matches || !t.matches('[data-sfsx-ins-toggle]')) return;
    var box = t.closest('.sfsx-ins-top, .sfsx-ins');
    if (!box) return;
    insKeep = { sel: (box.classList.contains('sfsx-ins-top') ? '.sfsx-ins-top' : '.sfsx-ins') + (/--page/.test(box.className) ? '[class*="--page"]' : ':not([class*="--page"])'), until: Date.now() + 5000 };
  }, true);
  function insulated() {
    if (!insKeep) return;
    if (Date.now() > insKeep.until) { insKeep = null; return; }
    if (!lostFocus()) return;
    var box = document.querySelector(insKeep.sel + ':not([hidden])');
    focusOn(box && box.querySelector('[data-sfsx-ins-toggle]'));
  }

  /* ---------- quick order ---------- */
  document.addEventListener('click', function (e) {
    var rm = e.target && e.target.closest ? e.target.closest('[data-qo-remove]') : null;
    if (!rm) return;
    var root = rm.closest('.sfsx-qo');
    setTimeout(function () { if (root && lostFocus()) focusOn(root.querySelector('[data-qo-search]')); }, 0);
  }, true);
  function quickOrder() {
    each(document, '.sfsx-qo', function (root) {
      var input = root.querySelector('[data-qo-search]'), list = root.querySelector('[data-qo-results]');
      set(root.querySelector('.sfsx-qo__totals'), 'role', 'status');
      set(root.querySelector('.sfsx-qo__totals'), 'aria-atomic', 'true');
      each(root, '[data-qo-remove]', function (b) {
        var n = txt(b.closest('[data-qo-row]') && b.closest('[data-qo-row]').querySelector('.sfsx-qo__name'));
        if (n) set(b, 'aria-label', 'Remove ' + n);
      });
      if (!input || !list) return;
      if (!list.id) list.id = (input.id || 'sfsx-qo-q') + '-list';
      set(input, 'role', 'combobox');
      set(input, 'aria-autocomplete', 'list');
      set(input, 'aria-controls', list.id);
      set(list, 'aria-label', 'Search warehouse items');
      var open = !list.hidden;
      set(input, 'aria-expanded', open ? 'true' : 'false');
      var active = null, count = 0;
      each(list, 'li', function (li, i) {
        if (!li.hasAttribute('data-idx')) { set(li, 'role', 'option'); set(li, 'aria-disabled', 'true'); return; }
        count++;
        if (!li.id) li.id = list.id + '-o' + i;
        var on = li.classList.contains('is-active');
        set(li, 'aria-selected', on ? 'true' : 'false');
        if (on) active = li;
      });
      if (open && active) set(input, 'aria-activedescendant', active.id); else input.removeAttribute('aria-activedescendant');
      var none = list.querySelector('.sfsx-qo__res--none');
      say(srNode(list.parentNode, 'qo'), !open ? '' : (none ? txt(none) : count + (count === 1 ? ' result' : ' results')));
      if (!list.__sfsxWatched) {
        list.__sfsxWatched = true;
        new MutationObserver(schedule).observe(list, { attributes: true, attributeFilter: ['class', 'hidden'], subtree: true });
      }
    });
  }

  /* ---------- run now, and again whenever the page changes ---------- */
  function run() {
    pauses(); names(); bundle(); insulated(); quickOrder();
  }
  var queued = false;
  function schedule() {
    if (queued) return;
    queued = true;
    var go = function () { queued = false; try { run(); } catch (err) {} };
    if (window.requestAnimationFrame) window.requestAnimationFrame(go); else setTimeout(go, 16);
  }
  function start() {
    run();
    if ('MutationObserver' in window) new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();